var map = {
	"./arpa.js": 17638,
	"./bel.js": 78583,
	"./bust.js": 59218,
	"./diamond.js": 16329,
	"./food.js": 49948,
	"./metal.js": 75286,
	"./nftbox.js": 54890,
	"./oland.js": 89686,
	"./water.js": 28793,
	"./wood.js": 24003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33340;